import { render, staticRenderFns } from "./manualAddNew.vue?vue&type=template&id=4fa21ddc&scoped=true"
import script from "./manualAddNew.vue?vue&type=script&lang=ts"
export * from "./manualAddNew.vue?vue&type=script&lang=ts"
import style0 from "./manualAddNew.vue?vue&type=style&index=0&id=4fa21ddc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa21ddc",
  null
  
)

export default component.exports